(function () {
  'use strict';

  angular
      .module('tfc.retailer.StoreSelection')
      .controller('StoreSelectionCtrl', StoreSelectionCtrl)
      .directive('tfcStoreSelection', tfcStoreSelection);

  function StoreSelectionCtrl($state, $stateParams, Auth, AnalyticsHelper) {
    var vm = this;

    vm.showSearch = (vm.userStores.length > 10) && Auth.getUser() && Auth.getUser().isInternal;

    vm.onToggle = function(open) {
      if(!open) {
        var storeKeys = fetchAndUpdateSelectedStores();
        AnalyticsHelper.sendStoreSelectionChangeEvent($stateParams.storeKey, storeKeys);
        $state.go('.', {storeKey: storeKeys}, {inherit: false});
      }
    };

    vm.onSelectionChange = function() {
      setShowSeparator();
    };

    // Initialise
    fetchAndUpdateSelectedStores();

    function fetchAndUpdateSelectedStores(){
      var selectedStores = getSelectedStores();

      if(_.isEmpty(selectedStores)){
        selectedStores = getDefaultStores();
      }

      var storeKeys = _.map(selectedStores,'storeKey');

      updateModel(storeKeys);
      setStoreKeyDisplay(selectedStores);
      setShowSeparator();

      return storeKeys;
    }

    function getSelectedStores() {
      return _.filter(vm.userStores, {isSelected: true});
    }

    function setShowSeparator() {
      vm.showSeparator = !_.every(vm.userStores, {isSelected: _.head(vm.userStores).isSelected})
    }

    function getDefaultStores(){
      var storeKeyParams = $stateParams.storeKey ?
          _.isArray($stateParams.storeKey) ? $stateParams.storeKey: [$stateParams.storeKey]: [];

      return (storeKeyParams.length) ? _.filter(vm.userStores, function (store) {
        return _.includes(storeKeyParams, store.storeKey);
      }) : vm.userStores.length > 10 ? [_.head(vm.userStores)] : vm.userStores;
    }

    function updateModel(selectedStoreKeys){
      _.forEach(vm.userStores,function(store) {
        store.isSelected = _.includes(selectedStoreKeys, store.storeKey);
      });
    }

    function setStoreKeyDisplay(selectedStores) {

      if(selectedStores.length > 1){
        vm.storeKeyDisplay = _.head(selectedStores).storeName + " + " + _.tail(selectedStores).length;
      } else if(selectedStores.length === 1) {
        vm.storeKeyDisplay = _.head(selectedStores).storeName;
      }
    }

  }

  function tfcStoreSelection() {
    return {
      restrict: 'E',
      bindToController : true,
      controller : 'StoreSelectionCtrl as vm',
      templateUrl : 'Util/StoreSelection/StoreSelection.tmpl.html',
      scope: {
        userStores: '='
      }
    };
  }

})();
